import React from 'react';
import { Router, Route, Link, hashHistory } from 'react-router';

import Avatar from 'material-ui/Avatar';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import ActionSettings from 'material-ui/svg-icons/action/settings';

import Header from '../components/header.jsx';
import Navigation from '../components/navigation.jsx';

const Home = React.createClass({
	componentDidMount: function() {
		let request = new XMLHttpRequest();
		request.open('GET', '/api/v2/images/avatars');
		request.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('token'));
		request.send(null);
		request.onreadystatechange = function() {
			if (request.readyState == 4) {
				if (request.status == 200) {
					this.setState({
						avatarList: JSON.parse(request.responseText)
					});
				}
			}
		}.bind(this);

		let userReq = new XMLHttpRequest();
		userReq.open('GET', '/api/v2/users');
		userReq.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('token'));
		userReq.send(null);
		userReq.onreadystatechange = function() {
			if (userReq.readyState == 4) {
				if (userReq.status == 200) {
					this.setState({
						avatar: JSON.parse(userReq.responseText).user.avatar
					});
				} else {
					hashHistory.push("/login");
				}
			}
		}.bind(this);

		this.props.selectView(0);
	},
	getInitialState: function() {
		return {
			headerTitle: 'Dashboard',
			username: localStorage.getItem('username'),
			avatar: 'badger',
			selectedAvatar: 'badger',
			selectedIndex: 0,
			avatarList: [],
			modalOpen: false,
		}
	},
	_handleOpen: function() {
		this.setState({
			modalOpen: true
		}, function(){
			const selectedAnimal = document.querySelector('img[data-type='+ this.state.avatar + ']');
			selectedAnimal.classList.add('selected');
		});
	},
	_handleClose: function() {
		this.setState({
			modalOpen: false
		});
	},
	_displayAvatarList: function() {
		const style = {
			thumbnail: {
				height: '60px',
				width: '60px',
				margin: '.4em .5em',
				opacity: '.7',
				backgroundColor: 'transparent',
				borderRadius: 'none',
				paddingBottom: '3px',
				borderBottom: '3px solid transparent',
			}
		}
		return this.state.avatarList.map((avatar) => {
			return (
				<Avatar
					key={avatar}
					data-type={avatar}
					className="animal"
					style={style.thumbnail}
					onTouchTap={this._selectAvatar}
					src={'/images/avatars/thumbnail/' + avatar + '.jpg'}
				/>
			)
		})
	},
	_selectAvatar: function(e) {
		if (document.querySelector('.selected')){
			document.querySelector('.selected').classList.remove('selected');
		}
		e.target.classList.add('selected');
		this.setState({
			selectedAvatar: e.target.dataset.type
		});
	},
	_saveAvatar: function() {
		this.setState({
			avatar: this.state.selectedAvatar
		}, function(){
			const userInfo = {
				avatar: this.state.avatar
			};
			let request = new XMLHttpRequest();
			request.open('PUT', '/api/v2/users');
			request.setRequestHeader('Content-Type', 'application/json');
			request.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('token'));
			request.send(JSON.stringify(userInfo));
			request.onreadystatechange = function() {
				if (request.readyState == 4) {
					this._handleClose();
				}
			}.bind(this);
		})
	},
	_selectView: function(index) {
		this.setState({
			selectedIndex: index
		});
	},
	render: function() {
		const style = {
			avatar: {
				height: '120px',
				width: '120px',
				margin: '1em',
				borderRadius: '0',
				backgroundColor: 'transparent',
			},
			edit: {
				position: 'absolute',
				top: '4.5em',
				right: '1em',
				height: '32px',
				width: '32px',
				fill: '#999',
			},
			modal: {
				width: '80%',
			},
			title: {
				color: '#82CCC8',
				padding: '.7em 1em',
			}
		}
		const avatars = this._displayAvatarList();
		const actions = [
			<RaisedButton label="Save" onTouchTap={this._saveAvatar} primary={true} />
		];
		return (
			<div className="view">
				<Header headerTitle={this.state.headerTitle} home={true} />
				<div className="dashboard content">
					<Avatar src={'/images/avatars/full/' + this.state.avatar + '.png'} style={style.avatar} />
					<h1>Welcome, {this.state.username}!</h1>
					<ActionSettings onTouchTap={this._handleOpen} style={style.edit} />
				</div>
				<Navigation
					selectView={this.props.selectView}
					selectedIndex={this.props.selectedIndex}
					activeQuiz={this.props.activeQuiz}
				/>
				<Dialog
					title="Update Your Avatar"
					actions={actions}
					contentStyle={style.modal}
					autoScrollBodyContent={true}
					open={this.state.modalOpen}
					onRequestClose={this._handleClose}
					titleStyle={style.title}
				>
					<p>Select one:</p>
					<div className="avatars">{avatars}</div>
				</Dialog>
			</div>
		)
	}
});

export default Home;


// WEBPACK FOOTER //
// ./src/views/dashboard.jsx